import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "contexts/AuthContext";
import { API_BASE } from "config/api";

const POLL_INTERVAL_MS = 60000;

export default function useAlerts() {
  const { token, isAuthenticated } = useAuth();
  const [alerts, setAlerts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const intervalRef = useRef(null);

  const fetchAlerts = useCallback(async () => {
    if (!token) return;
    try {
      const response = await fetch(`${API_BASE}/alerts`, {
        headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const json = await response.json();
      setAlerts(json?.data?.alerts || []);
    } catch (e) {
      console.error("Fetch alerts failed:", e);
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (!isAuthenticated) {
      setAlerts([]);
      return undefined;
    }

    fetchAlerts();
    intervalRef.current = setInterval(fetchAlerts, POLL_INTERVAL_MS);
    return () => clearInterval(intervalRef.current);
  }, [isAuthenticated, fetchAlerts]);

  return { alerts, count: alerts.length, isLoading, refetch: fetchAlerts };
}
